// New Earth $100M Global Animation Core
document.addEventListener('DOMContentLoaded', () => {
    // 1. Initialize GSAP ScrollTrigger
    gsap.registerPlugin(ScrollTrigger);

    // 2. Hero Section Portal Effect
    const heroImage = document.querySelector('.newearth-hero img');
    const heroContainer = document.querySelector('.newearth-hero .w-72, .newearth-hero .lg\\:w-80');

    if (heroImage && heroContainer) {
        gsap.to(heroContainer, {
            scrollTrigger: {
                trigger: '.newearth-hero',
                start: "top top",
                end: "bottom top",
                scrub: 1.5,
            },
            scale: 6,
            opacity: 0,
            ease: "power2.inOut"
        });
    }

    // 3. Product Reveal Section - Fade Up Cards
    const glassCards = document.querySelectorAll('.glass-card');
    glassCards.forEach((card, index) => {
        gsap.from(card, {
            scrollTrigger: {
                trigger: card,
                start: "top 85%",
                toggleActions: "play none none reverse"
            },
            y: 100,
            opacity: 0,
            duration: 1.5,
            ease: "power3.out",
            delay: index * 0.1
        });
    });

    // 4. Methodology Reveal - Text Stagger
    const methodologyText = document.querySelectorAll('.newearth-methodology h2, .newearth-methodology p, .newearth-methodology span');
    if (methodologyText.length > 0) {
        gsap.from(methodologyText, {
            scrollTrigger: {
                trigger: '.newearth-methodology',
                start: "top 75%",
                toggleActions: "play none none reverse"
            },
            y: 30,
            opacity: 0,
            stagger: 0.1,
            duration: 1.2,
            ease: "power2.out"
        });
    }

    // 5. Global Parallax Background
    gsap.utils.toArray('section').forEach(section => {
        const bg = section.querySelector('.animate-ethereal');
        if (bg) {
            gsap.to(bg, {
                scrollTrigger: {
                    trigger: section,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true
                },
                y: 150,
                ease: "none"
            });
        }
    });

    // Smooth scroll for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        });
    });

    // 6. Dual-State Dynamic Header (Seed.com Architecture)
    const header = document.getElementById('master-header');
    const nanoBar = document.getElementById('nano-bar');
    const headerContainer = document.getElementById('header-container');
    const headerLogo = document.getElementById('header-logo');
    let lastScrollY = window.scrollY;

    if (header) {
        window.addEventListener('scroll', () => {
            const currentScrollY = window.scrollY;

            // State 1: Top of page - Zero Gravity
            if (currentScrollY < 50) {
                header.classList.remove('bg-background-dark/80', 'backdrop-blur-md', 'border-white/10', '-translate-y-full');
                header.classList.add('bg-transparent', 'border-transparent');

                if (nanoBar) nanoBar.style.marginTop = "0px";
                if (headerContainer) {
                    headerContainer.classList.remove('h-20', 'lg:h-24');
                    headerContainer.classList.add('h-24', 'lg:h-32');
                }
                if (headerLogo) {
                    headerLogo.classList.remove('scale-[0.85]'); // Horizontal logo shrinks less to remain legible
                }
            }
            // State 2 & 3: Scrolled Down & Deep Scroll Logic
            else {
                header.classList.add('bg-background-dark/80', 'backdrop-blur-md', 'border-white/10');
                header.classList.remove('bg-transparent', 'border-transparent');

                if (nanoBar) nanoBar.style.marginTop = `-${nanoBar.offsetHeight}px`; // Physics-based morph collapse
                if (headerContainer) {
                    headerContainer.classList.add('h-20', 'lg:h-24'); // Shrink header
                    headerContainer.classList.remove('h-24', 'lg:h-32');
                }
                if (headerLogo) {
                    headerLogo.classList.add('scale-[0.85]'); // 10x Math: 15% reduction is optimal for horizontal text
                }

                // Deep Scroll Hiding (Only hide if we are far down to prevent jitter)
                if (currentScrollY > 400) {
                    if (currentScrollY > lastScrollY) {
                        // Scrolling down: Slide out of view
                        header.classList.add('-translate-y-full');
                    } else {
                        // Scrolling up: Snap back into view
                        header.classList.remove('-translate-y-full');
                    }
                } else {
                    header.classList.remove('-translate-y-full');
                }
            }
            lastScrollY = currentScrollY;
        }, { passive: true });
    }
});
